import { ListItem } from '@/components';
import { FC } from 'react';
import { TableCellProps } from './interfaces/Table';
const visualizeElementsAndSpacing = false;
const borderClassToVisualizeElementsAndSpacing = visualizeElementsAndSpacing
  ? 'border-white border'
  : '';
const TableCell: FC<TableCellProps> = ({
  mainText,
  subText,
  subSubText,
  mainTextSize,
  mainTextColor,
  subTextSize,
  subTextColor,
  leftIconUrl,
  leftIcon,
  leftIconWidth,
  leftIconHeight,
  leftIconBorderRadius,
  rightIconUrl,
  rightIcon,
  shouldMiddleAlignIconAndText,
  align = 'left',
  className = '',
}) => {
  const alignmentClass =
    align === 'right'
      ? 'text-right items-end'
      : align === 'center'
      ? 'text-center items-center'
      : 'text-left items-start';
  return (
    <div
      className={`flex flex-col relative z-10 overflow-hidden 
        ${alignmentClass} 
        ${className} 
        ${borderClassToVisualizeElementsAndSpacing}`}
    >
      <ListItem
        mainText={mainText}
        subText={subText}
        subSubText={subSubText}
        mainTextSize={mainTextSize}
        mainTextColor={mainTextColor}
        subTextSize={subTextSize}
        subTextColor={subTextColor}
        leftIcon={leftIcon}
        leftIconWidth={leftIconWidth}
        leftIconHeight={leftIconHeight}
        leftIconBorderRadius={leftIconBorderRadius}
        leftIconUrl={leftIconUrl}
        rightIconUrl={rightIconUrl}
        rightIcon={rightIcon}
        shouldMiddleAlignIconAndText={shouldMiddleAlignIconAndText}
        align={align}
      />
    </div>
  );
};
export default TableCell;
